import { Copy, Eye, EyeOff, Wrench } from 'lucide-react'

import { CommandProps } from '~/components/command-menu/types'
import { IS_PRODUCTION } from '~/constants/system'
import { toggleDevtoolsVisible } from '~/hooks/useDevtoolsVisible'

export const adminCommands: CommandProps[] = [
  {
    category: 'admin',
    label: () => 'View as workspace...',
    icon: () => <Eye />,
    onSelect: ({ actions: { setActiveView } }) => {
      setActiveView('select_admin_team')
    },
    isDisabled: ({ isSplitsAdmin }) => !isSplitsAdmin,
  },
  {
    category: 'admin',
    label: () => 'Stop viewing as workspace',
    icon: () => <EyeOff />,
    onSelect: ({ actions: { resetActiveOrg, setActiveView } }) => {
      resetActiveOrg()
      setActiveView(null)
    },
    isDisabled: ({ isSplitsAdmin, isOrgOverridden }) =>
      !isSplitsAdmin || !isOrgOverridden,
  },
  {
    category: 'admin',
    label: ({ devtoolsVisible }) =>
      `${devtoolsVisible ? 'Hide' : 'Show'} developer tools`,
    icon: () => <Wrench />,
    onSelect: ({ actions: { setActiveView } }) => {
      toggleDevtoolsVisible()
      setActiveView(null)
    },
    isDisabled: ({ isSplitsAdmin }) => !isSplitsAdmin || IS_PRODUCTION,
  },
  {
    category: 'admin',
    label: () => 'Copy workspace ID',
    icon: () => <Copy />,
    onSelect: ({
      activeOrgId,
      actions: { copyToClipboard, setActiveView },
    }) => {
      if (activeOrgId) copyToClipboard(activeOrgId, 'Workspace ID copied')
      setActiveView(null)
    },
    isDisabled: ({ isSplitsAdmin, activeOrgId }) =>
      !isSplitsAdmin || !activeOrgId,
  },
]
